import { useSiteSettings, type MaintenanceConfig } from '../context/SiteSettingsContext';

export type { MaintenanceConfig };

export function useMaintenanceMode() {
  const { maintenance, updateMaintenance, loading, error, refresh } = useSiteSettings();

  return {
    config: maintenance,
    setEnabled: (enabled: boolean) => updateMaintenance({ ...maintenance, enabled }),
    updateConfig: (updates: Partial<MaintenanceConfig>) => updateMaintenance({ ...maintenance, ...updates }),
    reset: () => updateMaintenance({
      enabled: false,
      message: 'Estamos realizando mejoras para ofrecerte una mejor experiencia.',
      eta: 'Volveremos pronto.',
      showAdminLink: true,
    }),
    loading,
    error,
    refresh
  };
}